import React from 'react';
import { Col, Card, CardHeader, CardBody } from 'reactstrap';
import Map, {
  Marker,
  Popup,
  MapProvider,
  FullscreenControl,
  GeolocateControl,
  NavigationControl,
} from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { config } from '../../../../config';
const { MAP_BOX_API_URL, MAP_BOX_API_TOKEN } = config;

const LiveTracking = React.memo(({ associateLocation, clientsSettings }) => {
  const [loading, setLoading] = React.useState(true); // Track loading state
  const [colSpan, setColSpan] = React.useState(8); // Track loading state

  React.useEffect(() => {
    !clientsSettings.enable_communication && setColSpan(12);
  }, [clientsSettings]);

  const [viewState, setViewState] = React.useState({
    longitude: 103.8198,
    latitude: 1.3521,
    zoom: 10.7,
    pitch: 40.5,
    bearing: -15.9,
  });

  const [selectedMarker, setSelectedMarker] = React.useState(null);

  const onMapLoad = () => {
    setLoading(false);
  };

  return (
    <Col xl={colSpan} lg={colSpan} md={colSpan} sm={12}>
      <MapProvider>
        <Card className="card-h-100">
          <CardHeader className="d-flex justify-content-between align-items-center bg-white">
            <h6 className="card-title mt-2">Live Tracking System</h6>
          </CardHeader>
          <CardBody>
            <div className="navigate-container">
              {loading && <div className="loader">Loading...</div>}
            </div>
            <Map
              {...viewState}
              id="siteMap"
              onMove={(evt) => setViewState(evt.viewState)}
              onLoad={onMapLoad}
              style={{ width: '100%', height: 400, marginTop: 10 }}
              mapStyle={MAP_BOX_API_URL}
              mapboxAccessToken={MAP_BOX_API_TOKEN}
            >
              {associateLocation.map((location, index) => (
                <React.Fragment key={location.id || index}>
                  <Marker
                    longitude={parseFloat(location.longitude)}
                    latitude={parseFloat(location.latitude)}
                    color={'#A6478E'}
                    onClick={() => setSelectedMarker(location)}
                  />
                  {selectedMarker?.id === location.id && (
                    <Popup
                      longitude={parseFloat(location.longitude)}
                      latitude={parseFloat(location.latitude)}
                      anchor="top"
                      onClose={() => setSelectedMarker(null)}
                      closeOnClick={false}
                    >
                      <p className="font-medium text-muted">
                        {location.name} | {location.type}
                      </p>
                    </Popup>
                  )}
                </React.Fragment>
              ))}
              <FullscreenControl />
              <GeolocateControl />
              <NavigationControl />
            </Map>
          </CardBody>
        </Card>
      </MapProvider>
    </Col>
  );
});

export default LiveTracking;
